(() => {
  if (customElements.get('shipment-tracker')) return;
  customElements.define('shipment-tracker', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelector('form').addEventListener('submit', event => { event.preventDefault(); this.track(); });
    }
    async track() {
      if (this.busy) return;
      const number = this.querySelector('input').value.trim().replace(/\s/g, '').toUpperCase();
      const message = this.querySelector('.tracking-message');
      const result = this.querySelector('.tracking-result');
      const button = this.querySelector('button');
      result.hidden = true;
      message.hidden = false;
      if (!/^[A-Z0-9-]{6,40}$/.test(number)) { message.textContent = 'Please enter a valid tracking number from your shipping email.'; return; }
      const endpoint = this.dataset.endpoint.trim();
      if (!endpoint) { message.textContent = 'Tracking on our website is coming soon. For now, use the Royal Mail tracking link in your shipping confirmation email, or contact our team.'; return; }
      if (!endpoint.startsWith('/apps/') || endpoint.includes('?') || endpoint.includes('#')) { message.textContent = 'Tracking is temporarily unavailable. Please contact our team.'; return; }
      this.busy = true;
      button.disabled = true;
      message.textContent = 'Looking up your parcel…';
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(`${endpoint}?tracking=${encodeURIComponent(number)}`, { headers: { Accept: 'application/json' }, signal: controller.signal });
        if (response.status === 404) throw new Error('No shipment found. Please check your number or try again later.');
        if (!response.ok) throw new Error('Tracking is temporarily unavailable. Please try again later.');
        const data = await response.json();
        const stages = ['ordered', 'shipped', 'out_for_delivery', 'delivered'];
        const stage = stages.indexOf(data.stage);
        if (!data.status || stage < 0 || !Array.isArray(data.events)) throw new Error('Tracking information is not available yet. Please try again later.');
        this.querySelector('[data-status]').textContent = data.status;
        this.querySelectorAll('.tracking-progress li').forEach((li, i) => {
          li.classList.toggle('is-complete', i <= stage);
          li.querySelector('span').textContent = i <= stage ? '✓' : String(i + 1);
          if (i === stage) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current');
        });
        const events = this.querySelector('[data-events]'); events.replaceChildren();
        data.events.forEach(event => {
          const li = document.createElement('li');
          const title = document.createElement('h3'); title.textContent = event.title || 'Shipment update'; li.append(title);
          if (event.description) { const p = document.createElement('p'); p.textContent = event.description; li.append(p); }
          const meta = document.createElement('p');
          const date = new Date(event.timestamp);
          meta.textContent = [Number.isNaN(date.getTime()) ? '' : new Intl.DateTimeFormat('en-GB', {dateStyle:'medium',timeStyle:'short',timeZone:'Europe/London'}).format(date) + ' (UK time)', event.location].filter(Boolean).join(' · ');
          li.append(meta); events.append(li);
        });
        this.querySelector('[data-event-count]').textContent = `${data.events.length} updates`;
        const items = this.querySelector('[data-items]'); items.replaceChildren();
        (Array.isArray(data.items) ? data.items : []).forEach(item => {
          const li = document.createElement('li'); li.textContent = `${item.title} — Qty: ${item.quantity}`; items.append(li);
        });
        this.querySelector('.tracking-items').hidden = !items.children.length;
        message.hidden = true; result.hidden = false;
      } catch (error) { message.textContent = error.name === 'AbortError' ? 'Tracking took too long. Please try again.' : error.message; }
      finally { clearTimeout(timeout); button.disabled = false; this.busy = false; }
    }
  });
})();
